export { default } from "./ShareAction";
